import { useTranslation } from 'react-i18next';

import { useAuth } from '@furality/frontend-stack';
import { Button } from '@furality/furality-purpose';
import LinkButton from '@/components/LinkButton.tsx';
import { CardLayout } from '@/components/layouts/index.tsx';
import Overlapping from '@/components/Overlapping.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

const Pending = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const enableDonations = useFlag('donations');

  return (
    <CardLayout title="shared.navigation.under_construction">
      <div className="mt-5 w-100">
        <Overlapping>
          <img
            alt="Furality logo"
            src="https://media.cdn.furality.online/image/logo/fox-logo.svg"
            className="img-fluid d-block mx-auto mt-5"
            style={{ maxWidth: '25em' }}
          />
          <div className="position-relative w-100">
            <button
              style={{
                width: '2.25em',
                height: '1em',
                bottom: '20%',
                left: '50%',
                opacity: 0,
                transform: 'translateX(-50%)',
              }}
              className="position-absolute"
              onClick={() => auth.login()}
              aria-hidden="true"
              tabIndex={-1}
            ></button>
          </div>
        </Overlapping>
      </div>
      <div className="mt-5 mb-5 text-center">
        <h1>{t('pending.fox_portal')}</h1>
        <h2 className="h4">{t('pending.registration_not_open')}</h2>
        {enableDonations ? (
          <p className="px-sm-8">{t('pending.donate_and_view_assets')}</p>
        ) : (
          <p className="px-sm-8">{t('pending.view_assets')}</p>
        )}
        <div className="d-flex align-items-stretch flex-column">
          {enableDonations && (
            <LinkButton to="/donate" className="my-2 mx-0 d-block">
              {t('pending.donation_page')}
            </LinkButton>
          )}
          <LinkButton to="/accounts" className="my-2 mx-0 d-block">
            {t('pending.account_assets')}
          </LinkButton>

          <Button
            className="my-2 mx-0 d-block"
            as="a"
            href="https://furality.org"
            variant="outline-primary"
          >
            {t('shared.pending.back_to_website')}
          </Button>
        </div>
      </div>
    </CardLayout>
  );
};

export default Pending;
